import { Tab, Tabs } from '@cmg/design-system';
import React, { useCallback } from 'react';

import type { TabValue } from './CalendarTabs.model';
import { CALENDAR_TAB_LABELS, CALENDAR_TABS } from './CalendarTabs.model';

export type CalendarTabsProps = Readonly<{
  onChange: (value: TabValue) => void;
  activeTab: TabValue;
}>;

export const CalendarTabs: React.FC<CalendarTabsProps> = ({ activeTab, onChange }) => {
  const handleTabChange = useCallback(
    (_: React.SyntheticEvent, nextTab: TabValue) => {
      onChange(nextTab);
    },
    [onChange]
  );

  return (
    <Tabs aria-label="Calendar navigation" value={activeTab} onChange={handleTabChange}>
      {CALENDAR_TABS.map(tab => (
        <Tab
          sx={{ minWidth: 0 }}
          key={tab}
          id={`${tab}-calendar-tab`}
          aria-controls={`${tab}-calendar-tabpanel`}
          label={CALENDAR_TAB_LABELS[tab]}
          value={tab}
        />
      ))}
    </Tabs>
  );
};
